export default {};



// WEBPACK FOOTER //
// ./src/libs/global-data.js